import PropTypes from 'prop-types'
import Modal from '../../components/common/Modal'
import SubmitButton from '../../components/common/buttons/SubmitButton'
import classNames from 'classnames'
import { useState, useEffect } from 'react'
import classes from './LinkInputModal.module.scss'

const LinkInputModal = ({ isOpen, onClose, onSubmit, initialUrl }) => {
  const [url, setUrl] = useState(initialUrl || '')

  useEffect(() => {
    setUrl(initialUrl || '')
  }, [initialUrl])

  const handleSubmit = () => {
    onSubmit(url.trim())
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classNames(classes.modal)}>
      <div className={classes.content}>
        <h2 className={classes.title}>Insert Link</h2>
        <input
          type='text'
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className={classes.input}
        />
        <div className={classes.actions}>
          <SubmitButton buttonMessage='Cancel' onClick={onClose} />
          <SubmitButton buttonMessage='Insert' onClick={handleSubmit} disabled={!url.trim()} />
        </div>
      </div>
    </Modal>
  )
}

LinkInputModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialUrl: PropTypes.string,
}

export default LinkInputModal
